export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** The reservation is held for 10 minutes, during which time the reservee should fill in their details. */
    Status["HELD"] = "HELD";
    /** The reservation has been reserved. */
    Status["RESERVED"] = "RESERVED";
    /** The reservation has been canceled. */
    Status["CANCELED"] = "CANCELED";
    /** The reservation has finished successfully. */
    Status["FINISHED"] = "FINISHED";
    /** The reservee didn't arrive. */
    Status["NO_SHOW"] = "NO_SHOW";
    /** The reservee occupied the table. */
    Status["SEATED"] = "SEATED";
    /** The reservee requested a reservation and is waiting for manual approval. */
    Status["REQUESTED"] = "REQUESTED";
    /** The owner declined a reservee's request. */
    Status["DECLINED"] = "DECLINED";
    /** The reservation is held for 10 minutes from the created time, during which time the reservee should pay. After payment is completed status will be changed automatically to RESERVED. */
    Status["PAYMENT_PENDING"] = "PAYMENT_PENDING";
})(Status || (Status = {}));
export var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    /** The reservation is created by a User. */
    Source["OFFLINE"] = "OFFLINE";
    /** The reservation is created by UoU. */
    Source["ONLINE"] = "ONLINE";
    /** The reservation is created by a User. It can be created without reservee data. */
    Source["WALK_IN"] = "WALK_IN";
})(Source || (Source = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNKNOWN"] = "UNKNOWN";
    /** A reservation is free of charge. */
    PaymentStatus["FREE"] = "FREE";
    /** A payment is not received yet. */
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** A corresponding to reservation order was fully payed. */
    PaymentStatus["PAID"] = "PAID";
    /** A corresponding to reservation order was refunded, but refund amount is less than order total price. */
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    /** A corresponding to reservation order was fully refunded. The refund amount equals total price. */
    PaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    /** A corresponding to reservation order was partially payed. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(PaymentStatus || (PaymentStatus = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["PARTY_PACING"] = "PARTY_PACING";
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
export var Set;
(function (Set) {
    Set["PUBLIC"] = "PUBLIC";
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Sort by number of matches. */
    SortType["COUNT"] = "COUNT";
    /** Sort by value of the field alphabetically. */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Sort in descending order. */
    SortDirection["DESC"] = "DESC";
    /** Sort in ascending order. */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Exclude missing values from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Include missing values in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values. */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value. */
    ScalarType["MIN"] = "MIN";
    /** Maximum value. */
    ScalarType["MAX"] = "MAX";
    /** Sum of values. */
    ScalarType["SUM"] = "SUM";
    /** Average of values. */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value. */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation where you can define a set of ranges - each representing a bucket. */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg. */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    Interval["YEAR"] = "YEAR";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["DAY"] = "DAY";
    Interval["HOUR"] = "HOUR";
    Interval["MINUTE"] = "MINUTE";
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value. */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation where you can define a set of ranges - each representing a bucket. */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg. */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within the previous one. */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Returns instances where any terms in the expression occur. */
    Mode["OR"] = "OR";
    /** Returns instances where all the terms in the expression occur. */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map